import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import envImage from '../env1.jpg';
import './Home.css';

function Home() {
  const navigate = useNavigate();
  const {
    user,
    error: authError,
    signInWithEmail,
    register,
    resetPassword
  } = useAuth();

  const [showLogin, setShowLogin] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [showPw, setShowPw] = useState(false);

  // Auto-populate invite code from URL ?invite=CODE
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('invite');
    if (code) setInviteCode(code.toUpperCase());
  }, []);

  useEffect(() => {
    if (user) navigate('/app');
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setBusy(true);
    try {
      if (showLogin) {
        await signInWithEmail(email, password);
      } else {
        if (!agree) return;
        const displayName = [firstName, lastName].filter(Boolean).join(' ').trim() || undefined;
        const res = await register(email, password, inviteCode, displayName);
        if (res?.success) {
          setMessage(res.message || 'Registration successful. Please verify your email.');
          setShowLogin(true);
        } else if (res?.error) {
          setMessage(res.error);
        }
      }
    } finally {
      setBusy(false);
    }
  };

  const onForgot = async () => {
    if (!email) {
      setMessage('Enter your email to receive a reset link.');
      return;
    }
    setBusy(true);
    try {
      const res = await resetPassword(email);
      if (res?.success) setMessage('Password reset email sent.');
      else if (res?.error) setMessage(res.error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="lp-root">
      <div className="lp-grid">
        <aside className="lp-left">
          <video 
            className="lp-video"
            src="https://ssblob1.blob.core.windows.net/alim/age.mp4"
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="lp-overlay" />
          <div className="lp-brand">
            <img 
              src="https://ssobjects.blob.core.windows.net/logo/logo.png" 
              alt="Heart Felt Souls" 
              style={{ height: '32px', width: 'auto' }}
            />
          </div>
        </aside>

        <main className="lp-right">
          <div className="lp-card">
            <h1 className="lp-title">{showLogin ? 'Welcome back' : 'Create an account'}</h1>
            <div className="lp-tagline">
              {showLogin ? 'Sign in to continue your journey' : 'Start preserving what matters most'}
            </div>
            <div className="lp-subtle">
              {showLogin ? (
                <>Don't have an account? <button type="button" className="lp-link" onClick={() => { setShowLogin(false); setMessage(''); }}>Create one</button></>
              ) : (
                <>Already have an account? <button type="button" className="lp-link" onClick={() => { setShowLogin(true); setMessage(''); }}>Log in</button></>
              )}
            </div>

            <form onSubmit={onSubmit}>
              {!showLogin && (
                <div className="lp-two">
                  <input className="lp-input" placeholder="First name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                  <input className="lp-input" placeholder="Last name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                </div>
              )}

              <input className="lp-input" placeholder="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
              <div className="lp-pw-wrap">
                <input className="lp-input" placeholder="Enter your password" type={showPw ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} />
                {password && (
                  <button type="button" className="lp-pw-toggle" onClick={() => setShowPw(v => !v)}>
                    {showPw ? 'Hide' : 'Show'}
                  </button>
                )}
              </div>

              {!showLogin && (
                <input
                  className="lp-input"
                  placeholder="Invite Code"
                  value={inviteCode}
                  onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
                  style={{ letterSpacing: '3px', fontFamily: 'monospace', textAlign: 'center' }}
                />
              )}

              {!showLogin && (
                <label className="lp-terms">
                  <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
                  <span>I agree to the <a href="https://www.heartfeltsouls.com/terms" target="_blank" rel="noopener noreferrer" className="lp-link">Terms & Conditions</a></span>
                </label>
              )}

              <button className="lp-btn" type="submit" disabled={busy || (!showLogin && (!agree || !inviteCode))}>
                {showLogin ? (busy ? 'Logging in…' : 'Log in') : (busy ? 'Creating…' : 'Create account')}
              </button>

              {showLogin && (
                <div className="lp-forgot">
                  <button type="button" className="lp-link" onClick={onForgot}>Forgot password?</button>
                </div>
              )}

              {(authError || message) && (
                <div className={`lp-note ${authError ? 'error' : ''}`}>{authError || message}</div>
              )}
            </form>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Home;


